module.exports = __webpack_public_path__ + "img/firefox.47c941e1.svg";